import React from 'react';
import Icon from '../../libraries/icons';

export default function NavButtonBar({ options, active, ...rest }) {
  return (
    <div className={"scrolling-wrapper " + (rest.className ? rest.className : "py-4")}>
      {options.map((option, index) => {
        return (
          <div key={index} className={
            "card white " 
            + (rest.buttonClassName ? rest.buttonClassName : " text-base-content items-start")
            + (option.route && active === option.route ? " active" : "")
          }
            onClick={option.onClick && (() => option.onClick(option.route))}
          >
            <Icon className={"" + option.iconClassName ? option.iconClassName : " h-10 w-10 mx-auto"} name={option.icon} />
            {option.content.map((element, index) => {
              return element;
            })}
          </div> 
        )
      })}
    </div>
  );
}